import { render, staticRenderFns } from "./HeaderModern.vue?vue&type=template&id=12013749&"
import script from "./HeaderModern.vue?vue&type=script&lang=js&"
export * from "./HeaderModern.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {BrandingLogoByMedel: require('/codebuild/output/src2284964156/src/med-el-hearpeers/components/Branding/LogoByMedel.vue').default,MenuMainModern: require('/codebuild/output/src2284964156/src/med-el-hearpeers/components/Menu/MainModern.vue').default,MenuMain: require('/codebuild/output/src2284964156/src/med-el-hearpeers/components/Menu/Main.vue').default,MenuMetaModern: require('/codebuild/output/src2284964156/src/med-el-hearpeers/components/Menu/MetaModern.vue').default})
